import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

export const fetchContracts = async (params = {}) => {
  try {
    const response = await api.get('/contracts', { params });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to fetch contracts');
  }
};

export const fetchContract = async (id) => {
  try {
    const response = await api.get(`/contracts/${id}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to fetch contract');
  }
};

export const fetchPDFUrl = async (contractId) => {
  try {
    const response = await api.get(`/pdf/${contractId}`);
    return response.data.fileUrl;
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to fetch PDF URL');
  }
};

export const fetchSourcePDFUrl = async (filePath) => {
  try {
    const response = await api.get(`/source/pdf`, {
      params: { path: filePath }
    });
    return response.data.fileUrl;
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to fetch source PDF URL');
  }
};

export const fetchContractsForSource = async (sourceId) => {
  try {
    const response = await api.get(`/source/contracts`, {
      params: { sourceId }
    });
    return response.data.contracts || [];
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to fetch contracts for source');
  }
};

export const fetchUserSession = async () => {
  try {
    const response = await api.get('/user');
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to fetch user session');
  }
};

export default api;